import { BrowserModule, HammerModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LayoutModule } from '@angular/cdk/layout';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AppMaterialModule } from './app.material.module';
import { QRCodeModule } from 'angularx-qrcode';
import { BaseChartDirective, provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { GridsterModule } from 'angular-gridster2';

import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BackendInterceptor } from './helpers/backend.interceptor';

import { PrinterComponent } from './printer/printer.component';
import { LabelPreviewComponent } from './label-preview/label-preview.component';
import { LabelComponent } from './label/label.component';
import { MainNavComponent } from './main-nav/main-nav.component';
import { LoginComponent } from './login/login.component';
import { ErrorComponent } from './error/error.component';
import { SidenavIconComponent } from './sidenav-icon/sidenav-icon.component';
import { SidenavTextComponent } from './sidenav-text/sidenav-text.component';
import { LabelPrintPageComponent } from './label-print-page/label-print-page.component';
import { AssetNewPageComponent } from './asset-new-page/asset-new-page.component';
import { AssetListPageComponent } from './asset-list-page/asset-list-page.component';
import { ClassListPageComponent } from './class-list-page/class-list-page.component';
import { PlaceListPageComponent } from './place-list-page/place-list-page.component';
import { AuthInterceptor } from './helpers/auth.interceptor';
import { ClassDialogComponent } from './class-dialog/class-dialog.component';
import { PlaceDialogComponent } from './place-dialog/place-dialog.component';
import { TableDetailAbstractComponent } from './table-detail-abstract/table-detail-abstract.component';
import { TableDetailHistoryComponent } from './table-detail-history/table-detail-history.component';
import { AssetDetailsDialogComponent } from './asset-details-dialog/asset-details-dialog.component';
import { AssetEditComponent } from './asset-edit/asset-edit.component';
import { DashboardPageComponent } from './dashboard-page/dashboard-page.component';
import { DashboardCardComponent } from './dashboard-card/dashboard-card.component';
import { SafeHtmlPipe } from './helpers/safeHtml.pipe';
import { DeleteDialogComponent } from './delete-dialog/delete-dialog.component';


@NgModule({
    declarations: [
        AppComponent,
        PrinterComponent,
        LabelPreviewComponent,
        LabelComponent,
        MainNavComponent,
        LoginComponent,
        ErrorComponent,
        SidenavIconComponent,
        SidenavTextComponent,
        LabelPrintPageComponent,
        AssetNewPageComponent,
        AssetListPageComponent,
        ClassListPageComponent,
        PlaceListPageComponent,
        ClassDialogComponent,
        PlaceDialogComponent,
        AssetDetailsDialogComponent,
        AssetEditComponent,
        TableDetailAbstractComponent,
        TableDetailHistoryComponent,
        DashboardPageComponent,
        DashboardCardComponent,
        DeleteDialogComponent,
        SafeHtmlPipe
    ],
    imports: [
        AppRoutingModule,
        AppMaterialModule,
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        LayoutModule,
        FlexLayoutModule,
        ScrollingModule,
        HammerModule,
        BaseChartDirective,
        QRCodeModule,
        GridsterModule
    ],
    providers: [
        provideCharts(withDefaultRegisterables()),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: BackendInterceptor,
            multi: true
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
